/** OpenAI Realtime audio is PCM16 mono at 24 kHz on both legs. */
export const VOICE_SAMPLE_RATE = 24000;

export const CAPTURE_WORKLET_URL = '/voice/pcm-24k-processor.js';
export const CAPTURE_WORKLET_NAME = 'pcm-24k-processor';
